<template>

    <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <a class="navbar-item" href="#">
                <img src="@/assets/saven_selection_picto.png" />
            </a>

            <a role="button" class="navbar-burger" :class="{'is-active': menuIsOpen}" aria-label="menu" aria-expanded="false" data-target="mainMenu" @click="menuIsOpen = !menuIsOpen">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>

        <div id="mainMenu" class="navbar-menu" :class="{'is-active': menuIsOpen}" :style="{height: menuHeight + 'px'}">
            <div class="navbar-start">

                <router-link :to="'/profile'" class="navbar-item profile_link"  @click.native="menuIsOpen = false">
                    <iconSettings /> <span class="nav_label">{{ username }}</span>
                </router-link>

                <router-link :to="'/'" class="navbar-item" :class="{active: isActiveFor(dashboardViewNames) }" @click.native="menuIsOpen = false">
                    <iconDashboard /> <span class="nav_label">{{ $t('layouts.user.nav.home') }}</span>
                </router-link>

                <router-link :to="'/refs'" class="navbar-item" :class="{active: isActiveFor(sightRefViewNames)}" @click.native="menuIsOpen = false">
                    <iconRef class="icon_ref" /> <span class="nav_label">{{ $t('layouts.user.nav.refs') }}</span>
                </router-link>

                <router-link :to="'/positions'" class="navbar-item" :class="{active: isActiveFor(positionsViewNames)}" @click.native="menuIsOpen = false">
                    <iconPosition /> <span class="nav_label">{{ $t('layouts.user.nav.positions') }}</span>
                </router-link>

                <router-link :to="'/evaluations'" class="navbar-item" :class="{active: isActiveFor(evaluationsViewNames)}" @click.native="menuIsOpen = false">
                    <iconEval class="icon_eval" /> <span class="nav_label">{{ $t('layouts.user.nav.evaluations') }}</span>
                </router-link>

            </div>

            <div class="navbar-end">

                <a target="_blank" class="navbar-item" href="http://saven.fr/aide-saven-selection/">
                     <iconHelp /> <span class="nav_label">{{ $t('layouts.user.nav.faq') }}</span>
                </a>
                <div class="mobile_locale_list">
                    <localeList v-if="localeSwitcherAccess" />
                </div>
            </div>
        </div>
    </nav>

</template>

<script>
import LogoSight from './logoSight'
import PictoSight from './pictoSight'
import LogoSaven from './logoSaven'
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'mobileNav',
    components: {
        LogoSight,
        LogoSaven,
        PictoSight
    },
    props: ["contentHeight"],
    data: function(){
        return {
            username: JSON.parse(localStorage.getItem('account')).user.username,
            userRole: JSON.parse(localStorage.getItem('account')).licence.account_type,
            currentRoute: this.$route.name,
            dashboardViewNames: ['Dashboard'],
            sightRefViewNames: ['RefIndex', 'RefNew', 'RefEdit'],
            positionsViewNames: ["PositionNew", "PositionIndex", "PositionCompare"],
            evaluationsViewNames: ['EvaluationsIndex', 'EvaluationsNew', 'EvaluationEdit'],
            menuIsOpen: false
        }
    },
    methods: {
        logout: function () {
            this.$store.dispatch('UserStore/logout', {})
                .then(() => this.$router.push('/login'))
                .catch(err => console.log(err))
        },
        isActiveFor(viewNames){
            return viewNames.includes(this.currentRoute)
        },
        goProfile(){
            this.$router.push('/profile')
        }
    },
    computed: {
        localeSwitcherAccess() {
            return userCanAccess('languages', 'english')
        },
        menuHeight() {
            if(this.menuIsOpen){
                return this.contentHeight
            }else{
                return 0
            }
        }
    },
    watch: {
            '$route' (to, from) {
                this.currentRoute = to.name
            }
        }
    }

</script>

<style lang="scss" >
$navbar-height: 60px;
nav.navbar{
    min-height: $navbar-height;
    max-height: $navbar-height;
    height: $navbar-height;
    .navbar-brand{
        background: $sidebar-bg-fallback;
        background: $sidebar-bg;
        min-height: $navbar-height;
        max-height: $navbar-height;
        height: $navbar-height;
        .navbar-item{
            width: $navbar-height;
            padding: 8px;
            img{
                max-height: 100%;
            }
        }
        .navbar-burger{
            min-height: $navbar-height;
            max-height: $navbar-height;
            height: $navbar-height;
            width: $navbar-height;
            span{
                background-color: #b6b6b6;
                width: 35px;
                height: 2px;
                left: 12px;
                &:nth-child(1) {
                    top: calc(50% - 12px);
                }
                &:nth-child(2) {
                    top: calc(50% );
                }
                &:nth-child(3) {
                    top: calc(50% + 12px);
                }
            }
            &.is-active{
                span:nth-child(1) {
                    transform: translateY(13px) rotate(45deg);
                }
                span:nth-child(2) {
                    top: calc(50% );
                }
                span:nth-child(3) {
                    transform: translateY(-10px) rotate(-45deg);
                }
            }
        }
    }
    .navbar-menu{
        position: absolute;
        width: 100%;
        background: $sidebar-bg-fallback;
        background: $sidebar-bg;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        overflow: hidden;
        transition: .3s height ease-in-out;
        padding: 0;
        &.is-active{
            display: flex;
        }
        .navbar-start{
            padding-top: 30px;
            width: 100%;
        }
        .navbar-end{
            padding-bottom: 30px;
            width: 100%;
        }
        .navbar-item{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            height: 60px;
            line-height: 60px;
            color: $sidebar-link-color;
            font-weight: 400;
            transition: .2s all;
            padding: 12px 20px;
            font-size: 1.2rem;
            svg{
                margin-right: 12px;
                width: 18px;
                max-height: 25px;
                fill: $sidebar-link-color;
                transition: .2s all;
                &.icon_eval, &.icon_ref{
                    width: 45px;
                    height: 45px;
                    margin-right: 0px;
                    margin-left: -13px;
                }
            }
            &:hover, &.active{
                background: $sidebar-bg-fallback;
                background: $sidebar-bg;
                color: $sidebar-link-color-active;
                svg{
                    // color: #666fff;
                    fill: $sidebar-link-color-active;
                    font-weight: 500;
                }
            }
            &.profile_link{
                border-bottom: 1px solid #3d3d3d;
            }
        }
        .mobile_locale_list{
            padding: 12px 20px;
        }
    }


}

</style>